import { api } from "@convex/_generated/api"; // Use alias
import { useMutation } from "convex/react";
import { Loader2 } from "lucide-react";
import React, { useState } from "react";
import { Modal } from "@/components/_shared/Modal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface LinkPasswordModalProps {
	isOpen: boolean;
	onClose: () => void;
	kuerzel: string;
	// nutzerHash: string; // Entfernt
	onSuccess: (message: string) => void;
	onError: (message: string) => void;
}

export function LinkPasswordModal({
	isOpen,
	onClose,
	kuerzel,
	// nutzerHash, // Entfernt
	onSuccess,
	onError,
}: LinkPasswordModalProps) {
	const [newPassword, setNewPassword] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const updatePasswordMutation = useMutation(
		api.linkShares.linkPasswortAktualisieren,
	);

	const handleSavePassword = async () => {
		setIsSubmitting(true);
		try {
			// nutzerHash Argument entfernt
			await updatePasswordMutation({
				kuerzel,
				passwort: newPassword.trim() || undefined,
			});
			onSuccess("Passwort erfolgreich aktualisiert.");
			setNewPassword(""); // Reset password field after success
		} catch (error) {
			onError("Fehler beim Aktualisieren des Passworts.");
			console.error("Error updating password:", error);
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Link-Passwort ändern">
			<div className="space-y-4 p-2">
				<div className="space-y-2">
					<Label htmlFor="new-link-password">Neues Passwort</Label>
					<Input
						autoFocus
						id="new-link-password"
						onChange={(e) => setNewPassword(e.target.value)}
						placeholder="Leer lassen, um Passwortschutz zu entfernen"
						type="password"
						value={newPassword}
					/>
					<p className="text-gray-500 text-xs dark:text-gray-400">
						Wenn du das Feld leer lässt, wird der Passwortschutz für diesen Link
						entfernt.
					</p>
				</div>
				<div className="mt-4 flex justify-end space-x-2">
					<Button
						disabled={isSubmitting}
						onClick={onClose}
						type="button"
						variant="outline"
					>
						Abbrechen
					</Button>
					<Button
						disabled={isSubmitting}
						onClick={handleSavePassword}
						type="button"
					>
						{isSubmitting ? (
							<>
								<Loader2 className="mr-2 h-4 w-4 animate-spin" />
								Speichern...
							</>
						) : (
							"Passwort speichern"
						)}
					</Button>
				</div>
			</div>
		</Modal>
	);
}
